import { APIRequestBody, APIResponse } from '../../types';
import { api } from '../../api';
import { AxiosRequestConfig } from 'axios';

export const authenticate_with_email = async (
  args: authenticate_with_email.Args,
  requestConfig?: AxiosRequestConfig
): Promise<authenticate_with_email.Response> => {
  const request: authenticate_with_email.Request = {
    service_name: 'UserAccountAuthentication',
    service_version: '1',
    service_method: 'authenticate_with_email',
    args,
  };

  return await api(request, requestConfig);
};

authenticate_with_email.queryKey =
  'UserAccountAuthentication/authenticate_with_email';

export declare namespace authenticate_with_email {
  export type Args = {
    email: string;
    password: string;
    device_platform: string;
    product_id: number;
  };

  export interface Request extends APIRequestBody {
    service_name: 'UserAccountAuthentication';
    service_version: '1';
    service_method: 'authenticate_with_email';
    args: Args;
  }

  export type Result = {
    user_uuid: string;
  };

  export type Response = APIResponse<Result>;
}
